import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { LineMessageLogQueryKey } from '../../constants'
import LineMessageLogService from '../services'
import {
	GetLineMessageLogsRequest,
	GetLineMessageLogsResponse,
} from '../../types'

function useQueryGetLineMessageLogs(
	params: GetLineMessageLogsRequest,
	props?: UseBaseQueryOptions<GetLineMessageLogsResponse>,
) {
	return useQuery({
		queryKey: [LineMessageLogQueryKey.GetLineMessageLogs, params],
		queryFn: () => LineMessageLogService.getLineMessageLogs(params),
		...props,
	})
}

export default useQueryGetLineMessageLogs
